import gql from 'graphql-tag'

export const QUERY_GET_VOUCHERS_ACTIVE = gql`
  query ActivatedVouchers(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $units: [ID]
    $units_configuration: [UnitConfigurationInput]
  ) {
    voucherInstances: activatedVouchers(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      units: $units
      units_configuration: $units_configuration
    ) {
      records
      page
      voucherInstances {
        _id
        user {
          _id
          document_no
          name
        }
        unit {
          _id
          id_erp
          name
        }
        money
        points
        activated_at
        consumed_at
        returned_at
      }
    }
  }
`

export const QUERY_GET_VOUCHERS_CONSUMED = gql`
  query ConsumedVouchers(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $initialDate: String
    $finalDate: String
    $units: [ID]
    $units_configuration: [UnitConfigurationInput]
  ) {
    voucherInstances: consumedVouchers(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      initialDate: $initialDate
      finalDate: $finalDate
      units: $units
      units_configuration: $units_configuration
    ) {
      records
      page
      voucherInstances {
        _id
        user {
          _id
          document_no
          name
        }
        unit {
          _id
          id_erp
          name
        }
        money
        points
        activated_at
        consumed_at
        returned_at
      }
    }
  }
`

export const QUERY_GET_CLIENTS_CANT_ACCUMULATE_POINTS = gql`
  query UsersBlockedDiscounts($search: String, $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection]) {
    usersBlockedDiscounts(page: $page, pageSize: $pageSize, search: $search, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      usersBlockedDiscounts {
        _id
        name
        created_at
        document_no
      }
    }
  }
`

export const QUERY_GET_PURCHASE_WITHOUT_POINTS = gql`
  query PurchasesWithUncreditedPoints($search: String, $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection]) {
    purchasesWithUncreditedPoints(page: $page, pageSize: $pageSize, search: $search, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      purchasesWithUncreditedPoints {
        id
        name
        document_no
        purchase_date
        purchases_over_limit
        total_purchases
        uncredited_points
      }
    }
  }
`

export const QUERY_GET_PURCHASE_WITHOUT_CASHBACK = gql`
  query PurchasesWithUncreditedCashback($search: String, $page: Int, $pageSize: Int, $sort: [String!], $sortDirection: [SortDirection!]) {
    purchasesWithUncreditedCashback(page: $page, pageSize: $pageSize, search: $search, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      purchasesWithUncreditedCashback {
        id
        name
        document_no
        purchase_date
        purchases_over_limit
        total_purchases
        uncredited_cashback
      }
    }
  }
`

export const QUERY_GET_USER_PURCHASE_LIMIT = gql`
  query UserPurchaseLimit {
    userPurchaseLimit
  }
`

export const QUERY_PURCHASE_LIMIT_POINTS = gql`
  query PointsDiscountsBlocksConfiguration {
    pointsDiscountsBlocksConfiguration {
      black_list {
        active
      }
      coupons_limit {
        active
        limit_per_day
      }
    }
  }
`

export const QUERY_PURCHASE_LIMIT_CASHBACK = gql`
  query CashbackDiscountsBlocksConfiguration {
    cashbackDiscountsBlocksConfiguration {
      black_list {
        active
      }
      coupons_limit {
        active
        limit_per_day
      }
    }
  }
`

export const MUTATION_PURCHASE_LIMIT_POINTS = gql`
  mutation UpdatePointsDiscountsBlocksConfiguration($black_list: InputPointsDiscountsBlocksBlackList, $coupons_limit: InputPointsDiscountsBlocksCouponsLimit) {
    updatePointsDiscountsBlocksConfiguration(black_list: $black_list, coupons_limit: $coupons_limit)
  }
`

export const MUTATION_PURCHASE_LIMIT_CASHBACK = gql`
  mutation UpdateCashbackDiscountsBlocksConfiguration(
    $black_list: InputCashbackDiscountsBlocksBlackList
    $coupons_limit: InputCashbackDiscountsBlocksCouponsLimit
  ) {
    updateCashbackDiscountsBlocksConfiguration(black_list: $black_list, coupons_limit: $coupons_limit)
  }
`

export const MUTATION_UPDATE_PURCHASE_LIMIT = gql`
  mutation UpdateUserPurchaseLimit($purchase_limit: Int!) {
    updateUserPurchaseLimit(purchase_limit: $purchase_limit)
  }
`

export const MUTATION_UNLOCK_USER_DISCOUNTS = gql`
  mutation UnlockUserDiscounts($_id: ID!) {
    unlockUserDiscounts(_id: $_id)
  }
`

export const MUTATION_EXPORT_CONSUMED_VOUCHERS_REPORT = gql`
  mutation CreateConsumedVouchersReport(
    $emails: [String!]!
    $final_date: String
    $initial_date: String
    $units: [String!]
    $units_configuration: [UnitConfigurationInput!]
    $fileFormat: FileFormatType
  ) {
    createConsumedVouchersReport(
      emails: $emails
      initial_date: $initial_date
      final_date: $final_date
      units: $units
      units_configuration: $units_configuration
      fileFormat: $fileFormat
    ) {
      id
      payload {
        emails
        fileFormat
      }
      state
    }
  }
`
